import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  title?: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmDeleteDialog({
  open,
  title = "Potwierdź usunięcie",
  description,
  confirmLabel = "Usuń",
  cancelLabel = "Anuluj",
  onConfirm,
  onCancel,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{t(title)}</DialogTitle>

      <DialogContent dividers>
        <Typography>{t(description)}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>
          {t(cancelLabel)}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
        >
          {t(confirmLabel)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
